<sim-icon-button
	#menuTrigger="matMenuTrigger"
	[matMenuTriggerFor]="menu"
	[tooltip]="T.CALENDAR_SORT_EVENTS | translate"
	fontSet="fad"
	icon="fa-arrow-up-arrow-down"
/>

<mat-menu
	#menu="matMenu"
	class="sortingMenu"
>
	<div class="sortingMenuContainer">
		<span class="sortingMenuTitle">{{ T.CALENDAR_SORT_EVENTS_BY | translate }}</span>
		@for (option of sortOptions; track option.value) {
			@let isSelected = selectedValue() === option.value;
			<button
				(click)="selectOption(option.value)"
				mat-menu-item
				class="sortMenuItem"
				[class.selectedMenuItem]="isSelected"
			>
				<mat-icon
					[fontSet]="option.icon.fontSet"
					[fontIcon]="option.icon.fontIcon"
				/>
				<span class="content">
					<span class="label">{{ option.label | translate }}</span>

					@if (isSelected) {
						<mat-icon>check</mat-icon>
					}
				</span>
			</button>
		}
		<mat-divider />
		<span class="sortingMenuTitle">{{ T.CALENDAR_SORT_ORDER | translate }}</span>

		<sim-segmented-button
			(click)="$event.stopPropagation()"
			[activeSegment]="activeOrderSegment()"
		>
			<sim-button-segment
				(onClick)="selectOrder('asc')"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-arrow-up-a-z'}"
				[title]="T.CALENDAR_SORT_ASCENDING | translate"
				[matTooltip]="ascTooltip() | translate"
			/>
			<sim-button-segment
				(onClick)="selectOrder('desc')"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-arrow-down-z-a'}"
				[title]="T.CALENDAR_SORT_DESCENDING | translate"
				[matTooltip]="descTooltip() | translate"
			/>
		</sim-segmented-button>
	</div>
</mat-menu>
